var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploreGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41,
    height: 38,
    viewBox: "0 0 41 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2601",
    d: "M0-682.665H20.7v20.7H0Z",
    transform: "translate(0 682.665)",
    fill: "#fe7878"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47862",
    "data-name": "Group 47862",
    transform: "translate(-1518 -673)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3152",
    "data-name": "Rectangle 3152",
    width: 41,
    height: 38,
    rx: 7,
    transform: "translate(1518 673)",
    fill: "#fff2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2595",
    transform: "translate(1528 681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2597",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2599",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2605",
    transform: "translate(0.606 0.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2607",
    d: "M-311.591-623.182a9.753,9.753,0,0,1-9.742-9.742,9.753,9.753,0,0,1,9.742-9.742,9.753,9.753,0,0,1,9.742,9.742A9.753,9.753,0,0,1-311.591-623.182Z",
    transform: "translate(321.333 642.665)",
    fill: "none",
    stroke: "#fe7878",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2609",
    transform: "translate(10.348 0.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2611",
    d: "M0-623.182c2.366,0,5.012-4.37,5.012-9.742S2.366-642.665,0-642.665",
    transform: "translate(0 642.665)",
    fill: "none",
    stroke: "#fe7878",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2613",
    transform: "translate(5.336 0.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2615",
    d: "M-160.321-623.182c-2.366,0-5.012-4.37-5.012-9.742s2.646-9.742,5.012-9.742",
    transform: "translate(165.333 642.665)",
    fill: "none",
    stroke: "#fe7878",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2617",
    transform: "translate(0.606 10.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2619",
    d: "M0,0H19.483",
    fill: "none",
    stroke: "#fe7878",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2621",
    transform: "translate(3.185 3.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2623",
    d: "M0,0A13.533,13.533,0,0,0,7.163,1.944,13.533,13.533,0,0,0,14.325,0",
    transform: "translate(0 0.003)",
    fill: "none",
    stroke: "#fe7878",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2625",
    transform: "translate(3.185 14.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2627",
    d: "M-458.2-62.272a13.533,13.533,0,0,0-7.163-1.947,13.533,13.533,0,0,0-7.163,1.947",
    transform: "translate(472.527 64.219)",
    fill: "none",
    stroke: "#fe7878",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2629",
    transform: "translate(10.348 0.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2631",
    d: "M0,0V19.483",
    fill: "none",
    stroke: "#fe7878",
    strokeWidth: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreGlobe);
export default __webpack_public_path__ + "static/media/explore-globe.e1820a49a56342aca19815d4a4fba58c.svg";
export { ForwardRef as ReactComponent };